import { nextActionVisual } from './nextActionIcons'
import { describeNextAction, type NextActionFields } from './nextActionText'

/**
 * The drawer's one-line version of the tag: the same icon and label, then
 * the sentence, under the employer's name. Nothing when there is nothing to
 * say.
 */
const NextActionLine = ({ voe }: { voe: NextActionFields }) => {
  const text = describeNextAction(voe)
  if (!text) return null
  const { Icon, iconClass, labelClass, label } = nextActionVisual(text)
  return (
    <div
      data-testid="next-action-line"
      className="flex items-center gap-1.5 text-xs text-doubleNickel-gray-700"
    >
      <Icon className={`h-3.5 w-3.5 flex-shrink-0 ${iconClass}`} />
      <span className={`font-medium ${labelClass}`}>{label}</span>
      <span className="text-doubleNickel-gray-400">·</span>
      <span>{text.sentence}</span>
    </div>
  )
}

export default NextActionLine
